/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, DocumentUseCasesControllerGetRemainingProcessingStepsPathParams, DocumentUseCasesControllerGetRemainingProcessingSteps401, DocumentUseCasesControllerGetRemainingProcessingSteps403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetRemainingProcessingSteps";

function getDocumentUseCasesControllerGetRemainingProcessingStepsUrl(processingId: DocumentUseCasesControllerGetRemainingProcessingStepsPathParams["processingId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/processings/${processingId}/steps/remaining` as const }  
  return res
}

/**
 * @description Returns steps that are still in progress or yet to be run (RUNNING, RETRYING, PENDING, RUNNABLE, FAILING) as a JSON:API array.
 * @summary Get remaining steps for a processing workflow
 * {@link /api/v1/documents/processings/:processingId/steps/remaining}
 */
export async function documentUseCasesControllerGetRemainingProcessingSteps(processingId: DocumentUseCasesControllerGetRemainingProcessingStepsPathParams["processingId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetRemainingProcessingSteps401 | DocumentUseCasesControllerGetRemainingProcessingSteps403>, unknown>({ method : "GET", url : getDocumentUseCasesControllerGetRemainingProcessingStepsUrl(processingId).url.toString(), ... requestConfig })  
  return res.data
}